// Example class
let _this = (module.exports = {
  // Set the dom elements
  dom: {
    body: document.querySelector("body"),
  },

  // Set variables
  vars: {
    flag: false,
  },
  toggle: function () {
    const footerColumnHeading = document.querySelectorAll(
      ".footer-body .widget-title",
    );

    if (window.innerWidth <= 991) {
      footerColumnHeading.forEach((heading) => {
        heading.addEventListener("click", () => {
          const childEl = heading.nextElementSibling;

          footerColumnHeading.forEach((item) => {
            if (item !== heading) {
              item.classList.remove("active");
              const el = item.nextElementSibling;
              if (el) el.classList.remove("active");
            }
          });

          heading.classList.toggle("active");
          if (childEl) childEl.classList.toggle("active");
        });
      });
    }
  },

  /**
   * Init functions
   */
  init: function () {
    this.toggle();
  },
});
